/* 🤖 this file was generated by svg-to-ts */
export const matIconCommit: {
  name: 'commit';
  data: string;
} = {
  name: 'commit',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16.9 11a5 5 0 0 0-9.8 0H2v2h5.1a5 5 0 0 0 9.8 0H22v-2h-5.1zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"/></svg>`
};
